import { render, staticRenderFns } from "./leergutComponent.vue?vue&type=template&id=158c50f6"
import script from "./leergutComponent.vue?vue&type=script&lang=js"
export * from "./leergutComponent.vue?vue&type=script&lang=js"
import style0 from "./leergutComponent.vue?vue&type=style&index=0&id=158c50f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports